module.exports = __webpack_public_path__ + "img/banner_title_sc.e4d39c37.gif";